import { Box, Typography } from '@mui/material';
import { ArrowCircleUpIcon } from '../Styles/arrows';
import {
  getSocialLoopTrendColor,
  socialLoopBodySx,
  socialLoopCardSx,
  socialLoopDescriptionIconSx,
  socialLoopDescriptionSx,
  socialLoopHeaderSx,
  socialLoopTitleSx,
} from '../Styles/socialLoopMetricCard';

const SocialLoopMetricCard = ({ title, value, description, isIncrease = true, titleAdornment }) => (
  <Box sx={socialLoopCardSx}>
    <Box sx={socialLoopHeaderSx}>
      <Typography variant="subtitle1" component="h2" sx={socialLoopTitleSx}>
        {title}
      </Typography>
      {titleAdornment}
    </Box>

    <Box sx={socialLoopBodySx}>
      <Typography variant="h4" component="span" color={getSocialLoopTrendColor(isIncrease)}>
        {value}
      </Typography>

      <Typography variant="body2" sx={socialLoopDescriptionSx(isIncrease)}>
        <ArrowCircleUpIcon sx={socialLoopDescriptionIconSx} />
        {description}
      </Typography>
    </Box>
  </Box>
);

export default SocialLoopMetricCard;
